export default "__VITE_ASSET__D40axn2i__"